import React from 'react'

import Base from '../_Base'

const Dismiss = (props) => (
  <Base width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      d="M0,8 C0,12.418 3.582,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 C3.582,0 0,3.582 0,8 Z"
      className="circle"
      fill="#a0a0a0"
    ></path>
    <path
      d="M9.4141,8 L11.7071,5.707 C12.0981,5.316 12.0981,4.684 11.7071,4.293 C11.3161,3.902 10.6841,3.902 10.2931,4.293 L8.0001,6.586 L5.7071,4.293 C5.3161,3.902 4.6841,3.902 4.2931,4.293 C3.9021,4.684 3.9021,5.316 4.2931,5.707 L6.5861,8 L4.2931,10.293 C3.9021,10.684 3.9021,11.316 4.2931,11.707 C4.4881,11.902 4.7441,12 5.0001,12 C5.2561,12 5.5121,11.902 5.7071,11.707 L8.0001,9.414 L10.2931,11.707 C10.4881,11.902 10.7441,12 11.0001,12 C11.2561,12 11.5121,11.902 11.7071,11.707 C12.0981,11.316 12.0981,10.684 11.7071,10.293 L9.4141,8 Z"
      className="cross"
    ></path>
  </Base>
)

export default Dismiss
